import React from "react";
import styled from "styled-components";
import TextInput from "common/TextInput";
import SelectInput from "common/SelectInput";
import PasswordInput from "common/PasswordInput";

const powercodeAPIBillingSubscribers = [
  { label: "Leave unchanged", value: "unchanged" },
  { label: "Customer-ID", value: "customer-id" },
  { label: "Name", value: "name" },
];

const dictionary = {
  'user-name': 'name',
}

function translate(input){
  return dictionary[input] ?? input;
}

const Wrapper = styled.div`
  > div {
    height: auto;
    margin-bottom: 20px;
  }
`;

const PowerCodeAPIBillingSettings = ({ onChange, defaults = {}, state }) => (
  <>
    <PasswordInput
      defaultValue={defaults.apikey}
      className="input-group"
      name="apikey"
      label="API key"
      onChange={onChange}
    />
    <TextInput
      type="text"
      label="Equipment Categories:"
      name="equipmentCategories"
      className="input-control"
      defaultValue={defaults.equipmentCategories}
      onChange={onChange}
    />
    <Wrapper>
      <SelectInput
        label="Subscriber-ID source"
        name="subscriberIdSource"
        onChange={onChange}
        defaultValue={defaults.subscriberIdSource ==="n/a" || defaults.subscriberIdSource === undefined ? "unchanged" : translate(defaults.subscriberIdSource)}
        options={powercodeAPIBillingSubscribers}
      />
    </Wrapper>
  </>
);

export default PowerCodeAPIBillingSettings;
